import React from 'react';

const TextBlock = ({ text }) => (
  <p className='inner-html margin-0 pt-0 pb-0' dangerouslySetInnerHTML={{__html: text}} />
);

export default TextBlock;
